// frontend/src/features/bapb/components/RefreshValuesModal.jsx
//
// Shared wider modal for the "Refresh Values Information" popup. Provides
// the chrome (header, count badge, close X) and a 2-column body: the
// section-specific intro text on the left, and the SupportedCadsPanel
// (Texas county map + searchable list) on the right.

import React, { useEffect } from "react";
import SupportedCadsPanel from "./SupportedCadsPanel";

export default function RefreshValuesModal({
  open,
  onClose,
  intro,
  supportedCads = [],
}) {
  // Close on Escape
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/55 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl flex flex-col w-[1200px] max-w-[95vw] h-[80vh] max-h-[860px] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <header className="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-gradient-to-r from-slate-50 to-white">
          <div>
            <h2 className="text-lg font-semibold text-slate-900">
              Refresh Values — Coverage
            </h2>
            <p className="text-xs text-slate-500 mt-0.5">
              Counties supported for live CAD value scraping
            </p>
          </div>
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={onClose}
              aria-label="Close"
              className="w-8 h-8 rounded-md text-slate-500 hover:bg-slate-100 hover:text-slate-700 flex items-center justify-center text-xl leading-none"
            >
              &times;
            </button>
          </div>
        </header>

        {/* Body — left intro, right map+list */}
        <div className="flex-1 flex overflow-hidden">
          <aside className="w-[320px] flex-shrink-0 border-r border-slate-200 bg-slate-50/40 p-5 overflow-y-auto">
            {intro}
          </aside>
          <div className="flex-1 overflow-hidden">
            <SupportedCadsPanel supportedCads={supportedCads} />
          </div>
        </div>

        {/* Footer */}
        <footer className="flex justify-end px-6 py-3 border-t border-slate-200 bg-slate-50">
          <button
            onClick={onClose}
            className="px-4 py-1.5 rounded-md border border-slate-300 bg-white text-sm text-slate-700 hover:bg-slate-100"
          >
            Close
          </button>
        </footer>
      </div>
    </div>
  );
}
